import React from 'react';

import Seo from '../components/seo';
import Layout from '../components/layout';
import Pagination from '../components/pagination';
import renderList from '../components/renderList';

const BlogPostList = ({ pageContext }) => {
  const { currentPage, numPages, posts, canonicalUrl, nextUrl, prevUrl } = pageContext;

  return (
    <Layout>
      <Seo canonicalUrl={canonicalUrl} nextUrl={nextUrl} prevUrl={prevUrl} />
      {posts.map(renderList)}

      <Pagination currentPage={currentPage} numPages={numPages} />
    </Layout>
  );
};

export default BlogPostList;
